import React from 'react';
import { useClient } from '@/stores/ClientContext';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

const ClientSelector = ({ fullWidth = false, variant = 'outlined', height = '34px' }) => {
  const { selectedClient, availableClients, selectClient } = useClient();

  const handleChange = (event) => {
    selectClient(event.target.value);
  };

  // If there are no available clients, don't render the component
  if (availableClients.length === 0) {
    return null;
  }

  return (
    <FormControl
      variant={variant} // Allows flexibility to change variant
      sx={{
        minWidth: fullWidth ? '100%' : 120,
        width: fullWidth ? '100%' : 'auto', // Set full width for the drawer
        height: height, // Adjust height for different use cases
        margin: 0,
        padding: 0,
        [`& .${outlinedInputClasses.root}`]: {
          height: height, // Adjust the height of the Select input
          fontSize: '0.875rem', // Adjust font size for better alignment
        },
      }}
      size="small" // Makes the select smaller
    >
      <InputLabel id="client-selector-label">Workspace</InputLabel>
      <Select
        labelId="client-selector-label"
        value={selectedClient?.id || ''}
        onChange={handleChange}
        label="Workspace"
      >
        {availableClients.map(client => (
          <MenuItem key={client.id} value={client.id}>
            {client.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ClientSelector;
